export function nullToUndefined<T>(val: T | null): T | undefined {
  return val !== null ? val : undefined;
}
